

import * as React from 'react';
import { useId } from 'react';

export const SpinnerIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} className={`animate-spin h-5 w-5 text-white ${className}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <title id={titleId}>Loading</title>
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
    )
};

export const UploadIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Upload file</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
        </svg>
    )
};

export const SparklesIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>AI sparkles</title>
            <path fillRule="evenodd" d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm6 0a1 1 0 011 1v1h1a1 1 0 010 2h-1v1a1 1 0 01-2 0V6h-1a1 1 0 010-2h1V3a1 1 0 011-1zM3.293 11.293a1 1 0 010 1.414l-1 1a1 1 0 01-1.414-1.414l1-1a1 1 0 011.414 0zm12.414 0a1 1 0 011.414 0l1 1a1 1 0 01-1.414 1.414l-1-1a1 1 0 010-1.414zM10 16a1 1 0 011 1v1h1a1 1 0 010 2h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 011-1z" clipRule="evenodd" />
        </svg>
    )
};

export const ChevronUpIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Collapse</title>
            <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
        </svg>
    )
};

export const ChevronDownIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Expand</title>
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
    )
};

export const ChevronLeftIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Previous</title>
            <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
        </svg>
    )
};

export const ChevronRightIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Next</title>
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
        </svg>
    )
};

export const ExportIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <title id={titleId}>Export</title>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
      </svg>
    )
};

export const TrendingUpIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <title id={titleId}>Trending up</title>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    )
};

export const DownloadIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <title id={titleId}>Download</title>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
      </svg>
    )
};

export const CheckCircleIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} className={`h-5 w-5 ${className}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <title id={titleId}>Success</title>
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
    )
};

export const SortIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Sort</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
        </svg>
    )
};

export const SunIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <title id={titleId}>Light mode</title>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    )
};

export const MoonIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <title id={titleId}>Dark mode</title>
        <path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
      </svg>
    )
};

export const DesktopIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <title id={titleId}>System theme</title>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    )
};

export const InfoIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Information</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
    )
};

export const UserCircleIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>User profile</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
    )
};

export const MenuIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Open menu</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
    )
};

export const XIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Close menu</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
    )
};

export const ChatBubbleIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Chat</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
    )
};

export const PaperAirplaneIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Send message</title>
            <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
        </svg>
    )
};

export const UserIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>User</title>
            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
        </svg>
    )
};

export const TagIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Category</title>
            <path fillRule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A1 1 0 012 10V5a1 1 0 011-1h5a1 1 0 01.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
        </svg>
    )
};

export const DocumentTextIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Feedback</title>
            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm2 1a1 1 0 011-1h6a1 1 0 011 1v3a1 1 0 01-1 1H7a1 1 0 01-1-1V5z" clipRule="evenodd" />
        </svg>
    )
};

export const GoogleIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg
            role="img"
            aria-labelledby={titleId}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={`h-5 w-5 flex-shrink-0 ${className ?? ''}`}
        >
            <title id={titleId}>Sign in with Google</title>
            <path fill="#4285F4" d="M21.35 11.1H12v3.6h5.39A5.07 5.07 0 0112 19.2c-3.05 0-5.52-2.47-5.52-5.52S8.95 8.16 12 8.16c1.31 0 2.49.45 3.41 1.2l2.55-2.55A8.58 8.58 0 0012 3.6C6.7 3.6 2.4 7.9 2.4 13.2S6.7 22.8 12 22.8c4.68 0 8.16-3.28 8.16-8.04 0-.54-.06-1.08-.17-1.56z" />
            <path fill="#34A853" d="M3.27 7.92l3.36 2.46A5.52 5.52 0 0112 8.16c1.31 0 2.49.45 3.41 1.2l2.55-2.55A8.58 8.58 0 0012 3.6c-3.33 0-6.2 1.9-7.65 4.32z" />
            <path fill="#FBBC05" d="M12 22.8c2.52 0 4.64-.84 6.19-2.28l-3.04-2.33a5.09 5.09 0 01-3.15 1.05 5.52 5.52 0 01-5.17-3.72l-3.34 2.56C4.88 20.43 8.15 22.8 12 22.8z" />
            <path fill="#EA4335" d="M21.35 11.1H12v3.6h5.39a4.63 4.63 0 01-1.67 2.45l3.04 2.33C20.93 18.56 21.6 15.96 21.6 13.2c0-.54-.06-1.08-.17-1.56z" />
        </svg>
    );
};

export const MicrosoftIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg
            role="img"
            aria-labelledby={titleId}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={`h-5 w-5 flex-shrink-0 ${className ?? ''}`}
        >
            <title id={titleId}>Sign in with Microsoft</title>
            <rect width="10.5" height="10.5" x="2.5" y="2.5" fill="#F35325" />
            <rect width="10.5" height="10.5" x="13" y="2.5" fill="#81BC06" />
            <rect width="10.5" height="10.5" x="2.5" y="13" fill="#05A6F0" />
            <rect width="10.5" height="10.5" x="13" y="13" fill="#FFBA08" />
        </svg>
    );
};

export const CheckIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Selected</title>
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
        </svg>
    )
};

export const MinusIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Partially selected</title>
            <path fillRule="evenodd" d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
        </svg>
    )
};

export const PencilIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Edit</title>
            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
        </svg>
    )
};

export const TrashIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
            <title id={titleId}>Delete</title>
            <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
    )
};

export const SaveIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Save</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
        </svg>
    );
};

export const HistoryIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>History</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
    );
};

export const FolderOpenIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Load</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z" />
        </svg>
    );
};

export const CompareIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Compare</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
    );
};

export const ChartBarIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Chart</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
    );
};

export const PackageIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Package</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
    );
};

export const ShieldCheckIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Verification</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
    );
};

export const ClipboardListIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Catalog</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
    );
};

export const CubeIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Inventory</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
    );
};

export const ActivityIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Activity</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
    );
};

export const DollarSignIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Pricing</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
    );
};

export const ChartIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Chart</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
    );
};

export const WarningIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Warning</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
    );
};

export const PlayIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 24 24" fill="currentColor">
            <title id={titleId}>Play video</title>
            <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
        </svg>
    );
};

export const CalculatorIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Calculator</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
    );
};

export const ArrowRightIcon: React.FC<{className?: string}> = ({ className }) => {
    const titleId = useId();
    return (
        <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <title id={titleId}>Arrow right</title>
            <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
    );
};